import { render } from "./LaunchIcon.vue?vue&type=template&id=36658c2c&scoped=true"
import script from "./LaunchIcon.vue?vue&type=script&lang=js"
export * from "./LaunchIcon.vue?vue&type=script&lang=js"

import "./LaunchIcon.vue?vue&type=style&index=0&id=36658c2c&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36658c2c"]])

export default __exports__